// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"552ed6f3","295":"154590e8","330":"b3c07ca9","859":"ab7127e3"}[chunkId] + ".chunk.js";
};